<template>
    <LeftSidebar :dark=true :open="showPermissionsEditor" :width="800" :updateSidebar="setShowPermissionsEditor" 
        :right="true"
        :temporary="true"
        style="z-index: 31 !important; ">
        
        <div slot="sbTitle">
            User Permissions 
        </div> 

        <div slot="sbContent" class="title mt-5">
            <v-layout class="pt-2 px-3" column fill-height > 


                <v-tabs
                	v-model="activeTab"
                    grow
                    color="red "
                    dark
                    icons-and-text
                  >
                    <v-tabs-slider color="indigo darken-2">
                    	
                    </v-tabs-slider>
                    <v-layout column>
	                    <v-layout>
		                    <v-tab>
		                      Employee
		                      <v-icon>face</v-icon>
		                    </v-tab>

		                    <v-tab>
		                      Dept / College
		                      <v-icon>dns</v-icon>
		                    </v-tab>

		                    <v-tab>
		                      Other
		                      <v-icon>hot_tub</v-icon>
		                    </v-tab>
		                </v-layout>
                   		<v-progress-linear class="my-0" height="4" v-if="!usersWithRights" color="blue" indeterminate></v-progress-linear>
                   	</v-layout>
                    <v-tab-item> <!------------- First Tab for Employees -->
                      <v-card flat>
                        <v-card-text>
                        	<EmployeeAutocomplete class="mr-2" label="Employee" :soloinverted="true" v-on:return-employee="setEmployee" :key="reset+3000"/> 
                        	<v-flex class="mt-3 ml-2" v-if="permissions && !hasPermissions">
                        		User has no space permissions
                        	</v-flex>

                        	<v-layout column class="mt-5" v-if="permissions">
			                    Role
			                    <v-autocomplete v-if="permissions"
			                                :items="filteredRolesEmployeeTab"  
			                                item-text="role"
			                                item-value="role"
			                                v-model="selectedRole"
			                                cache-items
			                                class="mb-5 mt-1"
			                                flat
			                                light
			                                hide-no-data
			                                hide-details
			                                label="Role"
			                                solo-inverted
			                                autofocus
			                                return-object
			                                @change="syncSelectedRole"
			                            ></v-autocomplete>              
			                    <v-layout column class="ml-5">
				                    Colleges
				                    <v-autocomplete v-if="selectedRole"
				                                :items="colleges"
				                                item-text="nameandid"
				                                item-value="id"
				                                v-model="selectedRole.collegeIDs"
				                                cache-items
				                                class="mb-5 mt-1"
				                                flat
				                                light
				                                hide-no-data
				                                hide-details
				                                label="Click to Assign Colleges"
				                                solo-inverted
				                                autofocus
				                                multiple
				                                deletable-chips
				                                @change="changed=true">
			                                <template v-slot:selection="data">
			                                    <v-chip
			                                      :selected="data.selected"
			                                      close
			                                      class="chip--select-multi"
			                                      @input="remove(selectedRole.collegeIDs, data.item.id)">
			                                    	<v-avatar class="ml-1">{{ data.item.id }}</v-avatar>
			                                    	{{ data.item.name }}
			                                    </v-chip>
			                                </template>                        
				                        </v-autocomplete>
				                    
				                    Departments
				                    <v-autocomplete v-if="selectedRole"
				                                :items="depts"
				                                item-text="deptNameAndID"
				                                item-value="deptID"
				                                v-model="selectedRole.deptIDs"
				                                cache-items
				                                class="mb-5 mt-1"
				                                flat
				                                light
				                                hide-no-data
				                                hide-details
				                                label="Click to Assign Departments"
				                                solo-inverted
				                                autofocus
				                                multiple
				                                chips
				                                deletable-chips
				                                @change="changed=true">				                             
			                            <template v-slot:selection="data">
			                                <v-chip
			                                  :selected="data.selected"
			                                  close
			                                  class="chip--select-multi"
			                                  @input="remove(selectedRole.deptIDs, data.item.deptID)"
			                                >
			                                  <v-avatar class="ml-1">
			                                    {{ data.item.deptID }}
			                                  </v-avatar>
			                                  {{ data.item.deptName }}
			                                </v-chip>
			                            </template>				                            
				                    </v-autocomplete>
				                </v-layout>

			                    <v-layout row v-if="changed" justify-space-between class="mt-5">
			                        <v-flex xs5><v-btn color="blue lighten-1" block @click="setPermissions">Save</v-btn> </v-flex>        
			                        <v-flex xs5><v-btn block @click="cancel">Cancel</v-btn></v-flex>
			                    </v-layout>
			                    <v-layout v-if="hasPermissions" class="mt-3">
			                        <v-flex>
			                            <v-btn outline block @click="clearPermissions" color="blue lighten-1">Clear Permissions
			                            </v-btn>
			                        </v-flex> 
			                    </v-layout>
			                </v-layout>
                        </v-card-text>
                        
                      </v-card>
                    </v-tab-item>

                    <v-tab-item>	<!------------------------- Tab for Department -->
                      	<v-card flat v-if="usersWithRights">
	                        
	                        	<v-layout class="px-2 mt-5" row justify-end>
	                        	<AutocompleteCollege class="mr-2"
		                        	:key="reset+2000"
			                        label="Filter College"
			                        :outline=true      
			                        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
			                        :prepend="''" 
			                        v-on:return-selection="selectCollege" />

	                        	<AutocompleteDepartment 
		                        	:key="reset+1000"
			                        label="Filter Department"
			                        :outline=true      
			                        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
			                        :prepend="''" 
			                        v-on:return-selection="selectDept" />
		                    </v-layout>
		                    

		                    <v-data-table 
								:headers="headers"
								:items="filteredUsersWithRights"
								hide-actions> 
								<template v-slot:items="props">
							  		<tr :id="props.item" :active="props.selected" >
										<td class="caption" v-for="header in headers">
											<div v-if="props.item[header.value] != 'X'" >
												<v-tooltip top>
	                                                <v-flex slot="activator" >
	                                                    <v-flex>{{ props.item[header.value] }}</v-flex>
	                                                </v-flex>
	                                                <span>{{ props.item[header.value] }}</span>
	                                            </v-tooltip>											
											</div>
											<div v-if="props.item[header.value]=='X'">
												<v-tooltip left>
							              			<v-dialog slot="activator" v-model="dialog[props.item.key]" persistent max-width="400">
														<v-icon slot="activator" small color="red lighten-2">close</v-icon>
														<v-card class="pl-2 pt-1 pr-2">
														        <v-card-title class="headline">REVOKE ALL PERMISSIONS</v-card-title>
														        <v-divider></v-divider>
														        <v-card-text class="pt-4 body-2">Revoke all permissions for {{props.item.name}} ?</v-card-text>
														        <v-card-actions>
														          	<v-spacer></v-spacer>
														          	<v-btn color="green darken-1" flat @click.native="dialog[props.item.key] = false">No</v-btn>
														          	<v-btn color="green darken-1" flat 
														          		@click.native="delRights(props.item)">Yes
														      	 	 </v-btn>
														        </v-card-actions>
												      	</v-card>
											    	</v-dialog>
									                <span>Revoke Permissions</span>
									            </v-tooltip>
										 	</div>

										</td>
									</tr>									
							  	</template> 
							</v-data-table>                    	                         
                      </v-card>
                    </v-tab-item>

                    <v-tab-item>	<!-- ---------------------- Tab for Other  -->
                      	<v-card flat v-if="usersWithRights && userRoleDescription">
	                        <v-card-text>
	                        	<v-layout column class="mt-5">
			                    OTHER ROLES
			                    <v-autocomplete :items="filteredOtherRoles"				                                
									item-text="role"
	                                v-model="selectedOtherRole"
	                                cache-items
	                                class="mt-3"
	                                flat	                                
	                                hide-no-data
	                                hide-details
	                                label="Select Role"
	                                solo-inverted
	                                autofocus
	                                :key="reset+5000"
	                                >	
	                            </v-autocomplete>
	                            <!-- {{selectedOtherRole && filteredUsersWithSelectedOtherRole}} -->
								<span class="subheading font-italic mt-2">{{ roleDescription }}</span>
	                            <v-flex>
	                            <v-flex v-if="filteredUsersWithSelectedOtherRole.length > 0" class="mt-5">Members</v-flex>
			        			<v-flex v-else-if="selectedOtherRole" class="mt-5">No Members</v-flex>
			        			<v-chip light close class="mt-3" v-for="member, index in filteredUsersWithSelectedOtherRole" :key="index" @input="removeUserFromOtherRole(member)">
				        		 	<span v-if="!member.remove">{{member.name}}</span>
				        		</v-chip>
				        		
				        		</v-flex>
	                            <EmployeeAutocomplete class="mt-2" :key="reset+4000" v-if="selectedOtherRole"
		        					label="+ Add Employee to Role (Name, number, or NetID)" 
		        					v-on:return-employee="addEmployeeToRole"> <v-icon>add</v-icon> </EmployeeAutocomplete>
		        				<v-layout row v-if="changed" justify-space-between class="mt-5">
			                        <v-flex xs5><v-btn color="blue lighten-1" block @click="confirmChangeRoleMembersDialog=true">Save</v-btn> </v-flex>        
			                        <v-flex xs5><v-btn block @click="cancel">Cancel</v-btn></v-flex>
			                    </v-layout>	
			                	</v-layout>
	                        </v-card-text>
                    	                         
                      </v-card>
                    </v-tab-item>

                </v-tabs>
            </v-layout>  

            <v-dialog v-model="confirmChangeRoleMembersDialog" persistent max-width="400">
				<v-card class="pl-2 pt-1 pr-2" v-if="confirmChangeRoleMembersDialog">
				        <v-card-title class="headline">CHANGE ROLE'S MEMBERS</v-card-title>
				        <v-divider></v-divider>
				        <v-card-text class="pt-4 body-2">Update {{selectedOtherRole}} Members:<br> {{filteredUsersWithSelectedOtherRole.length ? filteredUsersWithSelectedOtherRole.map((member) => member.name) : null}} <span v-if="!filteredUsersWithSelectedOtherRole.length">Clear All Members</span></v-card-text>
				        <v-card-actions>
				          	<v-spacer></v-spacer>
				          	<v-btn color="green darken-1" flat @click.native="confirmChangeRoleMembersDialog = false">No</v-btn>
				          	<v-btn color="green darken-1" flat 
				          		@click.native="updateRoleMembers">Yes
				      	 	 </v-btn>
				        </v-card-actions>
		      	</v-card>
	    	</v-dialog>              
        </div>
    </LeftSidebar>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import LeftSidebar from '@/components/LeftSidebar'
import EmployeeAutocomplete from '@/components/forms/EmployeeAutocomplete'
import AutocompleteDepartment from '@/components/forms/AutocompleteDepartment.vue'
import AutocompleteCollege from '@/components/forms/AutocompleteCollege.vue'

let permissionsEditor = {        

    data() {
      return {
      	activeTab: 0,
      	selectedDept: null,
      	selectedCollege: null,
      	reset: 0,
      	dialog: {},
        employee: null,
        selectedRole: null,
        selectedOtherRole: null,
        changed: false,
        permissions: null,
        confirmChangeRoleMembersDialog: false,
    	headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name'
          },
          { text: 'College', 	value: 'collegeID' 	},
          { text: 'Dept', 		value: 'deptName' 	},
          { text: 'Role', 		value: 'role' 		},
          { text: 'Revoke', 	value: 'revoke'			},	

        ],
		usersWithOtherRoleToRemove: [],
      }
    },

/*    mounted: async function() {
    	this.usersWithRights =  await this.fetchUsersWithRights()
    },*/

    watch: {
        employee (val) { 
            if (!val) { 
                this.clearAll()
            } 
        },

        showPermissionsEditor (val) {
            this.clearAll()
        },

        async activeTab (val) {
        	if (val == 1 || val == 2) {
        		this.setUsersWithRights(null)
        		await this.fetchUsersWithRights() // auto sets usersWithRights
        	}
        },
    },

    computed: {
        ...mapState({
            showPermissionsEditor: 	state => state.ui.showPermissionsEditor,
            depts:  				state => state.lists.depts,  
            colleges:  				state => state.lists.colleges,
            usersWithRights: 		state => state.user.usersWithRights,
			userRoleDescription:	state => state.user.userRoleDescription             
        }),

        updateUserList () {
			return this.usersWithRights && this.usersWithRights.filter((user) => user.new == true)
        },

        hasPermissions: function () {     
        	// Will count up individual permissions and return 0 if there are none.
            let count = 0       
            this.permissions && this.permissions.roles.forEach((role) => {
                count += role.collegeIDs.length  
                count += role.deptIDs.length               
            })
            return count                       
        },

        filteredUsersWithSelectedOtherRole () {
			return this.usersWithRights && this.usersWithRights.filter((user) => (user.role == this.selectedOtherRole && !user.remove))
        },

		filteredOtherRoles: function () { //All roles except manager and occupant_editor
			return this.userRoleDescription && this.userRoleDescription.filter((role) => role.roleID != 2 && role.roleID != 3)
		},

		filteredRolesEmployeeTab: function () { //Manager and occupant editor only
			return this.userRoleDescription && this.userRoleDescription.filter((role) => role.roleID == 2 || role.roleID == 3)
		},

		roleDescription: function () {
			return this.userRoleDescription && this.selectedOtherRole && this.userRoleDescription.filter((role) => role.role == this.selectedOtherRole)[0].description			
		},

        filteredUsersWithRights: function () {
        	if (this.selectedDept) { 
        		return this.usersWithRights.filter((user) => user.deptID == this.selectedDept.deptID)
        	}
        	if (this.selectedCollege) { 
        		return this.usersWithRights.filter((user) => user.collegeID == this.selectedCollege.id)
        	}
        	// else
        	return this.usersWithRights
        }

    },

    components: { LeftSidebar, EmployeeAutocomplete, AutocompleteDepartment, AutocompleteCollege },

    methods: {
        ...mapMutations([   'setShowPermissionsEditor', 'setUsersWithRights'
        ]),   
        ...mapActions([ 'fetchPermissionsByNetId', 'fetchSetPermissions', 'fetchUsersWithRights', 'updatePermissionsRoleMembers','fetchUserRoleDescription' ]),

        setEmployee(value) {
        	return new Promise((resolve, reject) => {
	            this.employee = value
	            this.permissions = null
	            if (value) {
	                this.fetchPermissionsByNetId(this.employee).then((data) => {
	                    this.permissions = data
	                    //Show Manager if already have manager roles, else show Occupant Editor
	                    if (data.roles.find(r => r.role === 'manager').collegeIDs.length > 0 || data.roles.find(r => r.role === 'manager').deptIDs.length > 0) {
	                    	this.selectedRole = data.roles.find(r => r.role === 'manager') // Manager
	                    } else { this.selectedRole = data.roles.find(r => r.role === 'occupant_editor') } // Occupant_editor
	                    resolve()
	                })
	               
	            }
        	})
        },

        syncSelectedRole(eventData) {
        	if (eventData.role == "manager") {
        		this.selectedRole = this.permissions.roles.find(r => r.role === 'manager') // Manager
        	} else { this.selectedRole = this.permissions.roles.find(r => r.role === 'occupant_editor') } // Occupant_editor
        },

        async delRights(user) {
        	let data = await this.setEmployee(user)
        	await this.clearPermissions()
        	this.dialog[user.key] = false     
        	this.setUsersWithRights(null)
        	await this.fetchUsersWithRights() // auto sets usersWithRights
        },

        selectDept : function (value) {
        	this.selectedDept = value
        	this.reset = this.reset+1
        },

        selectCollege : function (value) {
        	this.selectedCollege = value
        	this.reset = this.reset+1
        },

        setPermissions() {
            this.fetchSetPermissions(this.permissions)
            this.changed = false
        },

        cancel() {   
            this.setEmployee(this.employee)
            this.changed = false
        },

        clearAll() {
            this.permissions = null 
            this.selectedRole = null
            this.changed = false
            this.selectedOtherRole = null
            this.reset = this.reset+1
        },

        remove (list, removeMe) {
            const index = list.indexOf(removeMe)
            if (index >= 0) list.splice(index, 1)
            this.changed = true
        },

        clearPermissions: async function () {
            this.permissions.roles.forEach((role) => {
                role.collegeIDs = []
                role.deptIDs = []
            })
            await this.fetchSetPermissions(this.permissions)
            this.clearAll()
            this.changed = false
        },

        addEmployeeToRole(value) {
			let insert = { name: value.name, netid: value.netid, employeeID: value.employeeID, role: this.selectedOtherRole, add: true, remove: false }
		    this.usersWithRights.push(insert) // Putting it in here, is convenient for how the controls display
			this.reset=this.reset+1
			this.changed = true
		},

		async updateRoleMembers () {
			let payload = null
			if (this.usersWithOtherRoleToRemove.length > 0) { //If we have an array of users to remove from the selected role, include them in the v-chip list array as a new payload
				let combinedArray = this.filteredUsersWithSelectedOtherRole.concat(this.usersWithOtherRoleToRemove) 
					payload = { 
						role: this.selectedOtherRole, 
						members: combinedArray
					}
				}
				else { //We are just adding users to the role. Use the original array that populates the v-chip list
					payload = { 
						role: this.selectedOtherRole, 
						members: this.filteredUsersWithSelectedOtherRole
					}
				}
			
			await this.updatePermissionsRoleMembers(payload)
			this.confirmChangeRoleMembersDialog = false
			this.changed = false
			this.usersWithOtherRoleToRemove = [] //Reset users to remove from selected role array for next time
		},

		removeUserFromOtherRole (member) {
			member.remove = true;
			member.add = false;
			this.usersWithOtherRoleToRemove.push(member);
			this.changed=true
		}
    }
}

export default permissionsEditor
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PermissionsEditor.vue